import { jsx as o } from "react/jsx-runtime";
import { memo as F, useState as w, useEffect as C, useCallback as b } from "react";
import { Modal as _, Flex as j, Spin as v } from "antd";
import { a as M } from "./use-definition-0yWcQDPI.js";
import { K as P, b as m } from "./FormView-CWSNCHG6.js";
const S = "_modal_8nrjd_1", W = "_loadingWrap_8nrjd_14", u = {
  modal: S,
  loadingWrap: W
};
function k({
  open: p,
  entityName: t,
  mode: f,
  recordID: g,
  data: h,
  onClose: r
}) {
  const [e, d] = w(null), s = P(t, f), l = s === "create", c = l ? null : g ?? null, i = !!c && !e, [a] = M(t, c, {
    enabled: i
  });
  C(() => {
    a.data && !e && d(a.data);
  }, [a.data, e]);
  const n = b(() => {
    d(null), r();
  }, [r]), y = !l && !e && (a.isLoading || i);
  return /* @__PURE__ */ o(
    _,
    {
      open: p,
      onCancel: n,
      closable: !1,
      footer: null,
      centered: !0,
      width: "80vw",
      className: u.modal,
      destroyOnHidden: !0,
      maskClosable: !1,
      keyboard: !0,
      children: l ? /* @__PURE__ */ o(
        m,
        {
          entity: t,
          mode: s,
          data: h,
          onClose: n
        }
      ) : y ? /* @__PURE__ */ o(
        j,
        {
          justify: "center",
          align: "center",
          className: u.loadingWrap,
          children: /* @__PURE__ */ o(v, { size: "large" })
        }
      ) : e && /* @__PURE__ */ o(
        m,
        {
          entity: t,
          data: e,
          mode: s,
          onArchived: n,
          onClose: n
        }
      )
    }
  );
}
const x = F(k);
x.displayName = "PopupForm";
export {
  x as P
};
